/* Searchspring Custom Scripts */
document.addEventListener('DOMContentLoaded', (evt) => {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

    }
  
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
  
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      this.hidePanel();
      this.elements.button.focus();
    }
  
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);
  
  const ssQuickModalClose = document.querySelector('.ss__quick-modal-close');
  if (ssQuickModalClose) {
    ssQuickModalClose.addEventListener('click', (evt) => {
      const ssQuickModal = document.querySelector('.ss__quick-modal');
      ssQuickModal.classList.remove('active');
    });
  }

  window.events.on('addtocart', (evt) => {
    const ssQuickModal = document.querySelector('.ss__quick-modal');
    ssQuickModal.classList.remove('active');
  });

  /* Search */
  const headerSearchForm = document.querySelector('[data-header-search-form]');
  const headerSearchToggler = document.querySelector('[data-header-search-toggler]');
  const headerSearchClosers = document.querySelectorAll('[data-header-search-closer]');

  if (headerSearchForm) {
    headerSearchToggler.addEventListener('click', (evt) => {
      evt.preventDefault();
      headerSearchForm.classList.toggle('active');
      document.body.classList.remove('mobile-menu-opened');

      if (headerSearchForm.classList.contains('active')) {
        document.body.classList.add('search-form--opened');

        let headerSearchInput = document.querySelector('input#PredictiveSearch');
        // let headerSearchInput = document.querySelector('.searchspring-input.search-input--desktop');
        // if (window.innerWidth < 768) {
        //   headerSearchInput = document.querySelector('.searchspring-input.search-input--mobile');
        // }
        headerSearchInput.focus();
      } else {
        document.body.classList.remove('search-form--opened');
      }
    });

    headerSearchClosers.forEach(closer => {
      closer.addEventListener('click', (evt) => {
        evt.preventDefault();
        headerSearchForm.classList.remove('active');
        document.body.classList.remove('search-form--opened');
      });
    });
  }

  function accordionItemBlocks(){
    const allAccordionItemsBlocks = document.querySelectorAll('.section-blocks__accordion-item');
    console.log('allAccordionItemsBlocks', allAccordionItemsBlocks);

    allAccordionItemsBlocks.forEach(item => {
        const title = item.querySelector('.accordion-item__title');

        title.addEventListener('click', () => {
          console.log('click insection-blocks__accordion-item ')
          allAccordionItemsBlocks.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove('active');
            }
          });

          item.classList.toggle('active');
        });
    });
  }
  accordionItemBlocks();

  function tabbedBlocks(){
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('tab-title')) {
          const tabbedParent = event.target.closest('.section-blocks__tabbed-content');
          const clickedItem = event.target;
          const tabbedItems = [...tabbedParent.querySelectorAll('.tab-title')];
          const tabbedContents = [...tabbedParent.querySelectorAll('.tab-content')];
    
          tabbedItems.forEach(item => item.classList.remove('active'));
          tabbedContents.forEach(item => item.classList.remove('active'));
    
          clickedItem.classList.add('active');
          tabbedParent.querySelector(`.tab-content[data-target="${ clickedItem.getAttribute('data-target') }"]`).classList.add('active');
      }
    });
  }
  tabbedBlocks();

});

const storefrontToken = '18ea4f64442c2c2c2c3fcc88ba61ad46';
const apiUrl = 'https://luxyhair.myshopify.com/api/2023-10/graphql';
const apiHeaders = new Headers({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Shopify-Storefront-Access-Token': storefrontToken
});
let isFirstPageLoad = true;
let stackedRecsRequest = 0;

const ssQuickView = () => {
  const ssQuickViewBtns = document.querySelectorAll('.ss__product-quick-view:not(.event-attached)');

  if (ssQuickViewBtns) {
    ssQuickViewBtns.forEach((btn) => {
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        btn.classList.add('event-attached');

        if (window.loadingQuickView) {
          return false;
        }
        
        const productUrl = btn.dataset.href;
        const ssQuickModal = document.querySelector('.ss__quick-modal');

        window.loadingQuickView = true;
  
        $.ajax({
          url: `${productUrl}?view=ss-quick-view`,
          type: "GET",
          success: function (html) {
            const ssQuickModalContent = ssQuickModal.querySelector('.ss__quick-modal-content');
  
            ssQuickModalContent.innerHTML = html;
            ssQuickModal.classList.add('active');
            window.loadingQuickView = false;
            window.events.trigger("pjax:load");
            // Close modal on PDP redirect
            ssQuickModalContent.querySelector('.ss__quickview-top a').addEventListener('click', (evt) => {
              ssQuickModalClose.dispatchEvent(new Event('click'));
            });
          }
        });
      })
    });
  }
}

const ssAddToCart = () => {
  const ssAtcBtns = document.querySelectorAll('.ss__product-atc:not(.event-attached)');

  if (ssAtcBtns) {
    ssAtcBtns.forEach((btn) => {
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        const productData = JSON.parse(btn.dataset.json);
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: 'id=' + productData.variant.id + '&quantity=' + 1,
          dataType: 'json',
          success: function(response){
            console.log(response);
            window.events.trigger("addtocart");
            // window.location.href = '/cart';
          }
        });
      })
    });
  }
}

const ssProductImageCarouselInit = (showExampleGesture) => {
  const ssProductImageCarousels = document.querySelectorAll('.ss_product-image-carousel .swiper:not(.swiper-initialized)');

  if (ssProductImageCarousels) {
    ssProductImageCarousels.forEach((carousel) => {
      const swiper = new Swiper(carousel, {
        slidesPerView: 1,
        pagination: {
          el: carousel.querySelector('.swiper-pagination'),
          clickable: true
        }
      });
    });

    if (showExampleGesture) {
      const targetCarousel = ssProductImageCarousels[0];
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !entry.target.classList.contains('ss-example-gesture-finished')) {
            entry.target.classList.add('ss-example-gesture');
          }
        });
      }, {
        rootMargin: "0% 0% 0% 0%"
      });
      observer.observe(targetCarousel);

      targetCarousel.swiper.on('beforeSlideChangeStart', function () {
        targetCarousel.classList.remove('ss-example-gesture');
        targetCarousel.classList.add('ss-example-gesture-finished');
      });
    }
  }
}

/* Searchspring Events */
window.addEventListener('searchspring-recs-loaded', () => {
  console.log('start:searchspring-recs-loaded');

  const ssProductItems = document.querySelectorAll('.ss-recommended-products .ss__product-item:not(.ss__product-item--updating):not(.ss__product-item--updated)');
  fetchProductListing(ssProductItems, '.ss-recommended-products');

  // ssProductImageCarouselInit();
  ssQuickView();
  ssAddToCart();
});

window.addEventListener('searchspring-content-loaded', () => {
  console.log('searchspring content loaded');

  const ssProductBanners = document.querySelectorAll('.ss__result.ss__banner');
  ssProductBanners.forEach((banner) => {
    if (banner.querySelector('[data-banner-type]').dataset.targetUrl && banner.querySelector('[data-banner-type]').dataset.targetUrl.includes('hk-entry-widget-open')) {
      banner.setAttribute('data-us-ca-only', '');
    }
  })
  
  const ssProductColorSwatches = document.querySelectorAll('.ss__product-colors img');
  const ssProductItems = document.querySelectorAll('.ss__results .ss__product-item:not(.ss__product-item--updating):not(.ss__product-item--updated)');
  let productIds = [...ssProductItems].map((item) => {
    return `"gid://shopify/Product/${item.dataset.productId}"`;
  }).filter(onlyUnique);

  fetchProductListing(ssProductItems, '.ss__results');
  
  window.loadingQuickView = false;

  if (isFirstPageLoad) {
    window.scrollTo({
      top: localStorage.getItem("ss_scrolled_position"),
      behavior: 'smooth'
    });
    isFirstPageLoad = false;
  }

  // if (ssPrices) {
  //   ssPrices.forEach((price) => {
  //     if (price.classList.contains('ss__price--converted')) {
  //       return;
  //     }
  //     const value = price.dataset.value;
  //     price.textContent = (Currency.convert(value * 100, 'USD', Shopify.currency.active) / 100).toFixed(2);
  //     price.classList.add('ss__price--converted');
  //   })
  // }
  
  ssQuickView();
  
  if (ssProductColorSwatches) {
    ssProductColorSwatches.forEach((swatch) => {
      const productWrapper = swatch.closest('.ss__product');
      const productMainImage = productWrapper.querySelector('.ss__product-image-main');
  
      swatch.addEventListener('mouseenter', (evt) => {
        const previewImage = swatch.dataset.srcPreview;
        productMainImage.setAttribute('src', previewImage);
        productWrapper.classList.add('swatch-hovering');
      });
  
      swatch.addEventListener('mouseleave', (evt) => {
        const originImage = productMainImage.dataset.srcOrigin;
        productMainImage.setAttribute('src', originImage);
        productWrapper.classList.remove('swatch-hovering');
      });
    });
  }
  
  ssProductImageCarouselInit(true);
});

function getCollectionHandle() {
  let url = window.location.href;
  let handle = 'none';
  if( url.includes('/collections/') ) {
    handle = url.split('/collections/')[1].split('/')[0].split('?')[0]
  }
  return handle;
}

let scrolls = {};
let collection = getCollectionHandle();

window.addEventListener("beforeunload", function (e) {
  localStorage.setItem("last_page_url", window.location.href);
});

window.addEventListener('scroll', (evt) => {
  if (!isFirstPageLoad) {
    scrolls[collection] = window.scrollY;
    localStorage.setItem("ss_scrolled_position", JSON.stringify(scrolls));
  }
})

// window.addEventListener('popstate', (evt) => {
//   isFirstPageLoad = true
// })

function fetchProductListing(ssProductItems, containerClass) {
  ssProductItems.forEach((item) => {
    item.classList.add('ss__product-item--updating');
  });

  let productIds = [...ssProductItems].map((item) => {
    return `"gid://shopify/Product/${item.dataset.productId}"`;
  }).filter(onlyUnique);

  const query = () => `query @inContext(country: ${Shopify.country}) {
    nodes(ids: [${productIds.join(',')}]) {
      ...on Product {
        id
        variants(first: 1) {
          edges {
            node {
              compareAtPrice {
                amount
                currencyCode
              }
              price {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }`;

  fetch(apiUrl, {
    method: 'POST',
    headers: apiHeaders,
    body: JSON.stringify({query: query(), variables: {}})
  }).then((response) => response.json())
  .then((data) => {
    data.data.nodes.forEach((product) => {
      if(product) {
        const productId = product.id.replace("gid://shopify/Product/", "");
        const productPrice = product.variants.edges ? product.variants.edges[0].node.price.amount*100 : 0;
        const compareAtPrice = product.variants.edges[0].node.compareAtPrice ? product.variants.edges[0].node.compareAtPrice.amount*100 : 0;
        const matchedItems = document.querySelectorAll(`${containerClass} .ss__product-item[data-product-id="${productId}"]`);

        if (matchedItems) {
          matchedItems.forEach((item) => {
            if (compareAtPrice > productPrice) {
              item.querySelector('.ss__product-price').innerHTML = `
                <span class="ss__price ss-price__compare">${Shopify.formatMoney(compareAtPrice, window.theme.moneyWithCurrencyFormat)}</span>
                <span class="ss__price ss-price__sale">${Shopify.formatMoney(productPrice, window.theme.moneyWithCurrencyFormat)}</span>
              `;
            } else {
              item.querySelector('.ss__product-price').innerHTML = `
                <span class="ss__price ss-price__regular">${Shopify.formatMoney(productPrice, window.theme.moneyWithCurrencyFormat)}</span>
              `;
            }
    
            item.classList.add('ss__product-item--updated');
          })
        }
      }
    });

    ssProductItems.forEach((item) => {
      item.classList.remove('ss__product-item--updating');
    });
  });
}

function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}

// Tabbed Split content Tabs Controler
document.addEventListener("DOMContentLoaded", function() {
  var tabbedSplitContentTabs = document.querySelectorAll('.tabbed-split-content');

  console.log('tabbedSplitContentTabs', tabbedSplitContentTabs);
      
  tabbedSplitContentTabs.forEach(function (tabbedContent, index) {
    console.log('tabbedSplitContentTabs', tabbedSplitContentTabs)
    if (tabbedContent) {
      var tabItems = tabbedContent.querySelectorAll('.tab-titles .button[data-tab]');
      var tabContents = tabbedContent.querySelectorAll('.tab-contents .as-tab');
  
      console.log('tabItems', tabItems)
    
      tabItems.forEach(function (tabItem, index) {
        tabItem.addEventListener('click', function () {
          console.log('click at tabItem', tabItem);
          tabItems.forEach(function (tabItem) {
            return tabItem.classList.remove('active');
          });
          tabContents.forEach(function (tabContent) {
            return tabContent.classList.remove('active');
          });
          tabItem.classList.add('active');
          tabContents[index].classList.add('active');
        });
      });
    }
  })
});